export function isProduction() {
    return window.location.host === "cloud.ravendb.net";
}

export function persistentCookieMaxAge() {
    return 365 * 24 * 60 * 60;
}
